module.exports = __webpack_public_path__ + "assets/img/question.15050a71.png";